
import Vue from "vue";
import eventBus from "@/application/eventBus";

type Callback = () => void;

interface ComponentData {
  showDialog: boolean;
  confirmCallback: null | Callback;
  title: string;
  body: string;
  showCancel: boolean;
}

export default Vue.extend({
  name: "TheConfirmationDialog",
  data: (): ComponentData => ({
    showDialog: false,
    confirmCallback: null,
    title: "",
    body: "",
    showCancel: true,
  }),
  created() {
    eventBus.$on("confirm", (params: ComponentData) => {
      this.title = params.title;
      this.body = params.body;
      this.showCancel = params.showCancel ?? true;
      this.confirmCallback = params.confirmCallback;
      this.showDialog = true;
    });
  },
  methods: {
    handleContinue(): void {
      this.showDialog = false;

      if (typeof this.confirmCallback === "function") {
        this.confirmCallback();
      }
    },
  },
});
